import { lotsUIEventInstance } from '@annto/ui';
import { MdMessage } from 'mdesign3';
import { apiReport } from '@/api/common';
import { getDictList } from '@/api/userApi';
import http from '@/utils/http';

const EXPORT_API = `${apiReport}/report/task/export`;

export interface SubmitReportExportOptions {
  reportCode: string;
  searchData?: Record<string, unknown>;
  initialParams?: Record<string, unknown>;
}

interface ReportExportResponse {
  code: number | string;
  msg?: string;
  timestamp?: string;
  data?: {
    reportFileInfoId?: string;
  };
}

/**
 * 通用报表导出（对齐 OTP reportExportPlugin.submit）
 */
export async function submitReportExport(options: SubmitReportExportOptions): Promise<boolean> {
  const { reportCode, searchData = {}, initialParams } = options;
  if (!reportCode) {
    return false;
  }

  const dictRes = await getDictList({ dictCodes: reportCode });
  if (+dictRes.code !== 0 || !dictRes.data?.[reportCode]) {
    MdMessage.warning('获取导出配置失败');
    return false;
  }

  let params: Record<string, unknown> = { ...(dictRes.data[reportCode] || {}) };
  if (initialParams) {
    params = { ...params, ...initialParams };
  }
  params = { ...params, ...searchData };
  Reflect.deleteProperty(params, 'pageSize');
  Reflect.deleteProperty(params, 'pageNo');

  const reportRes = (await http.post(EXPORT_API, params)) as ReportExportResponse;
  if (reportRes && (+reportRes.code === 0 || reportRes.code === '0')) {
    lotsUIEventInstance.trigger('loopGetNewFile', {
      id: reportRes.data?.reportFileInfoId,
      time: reportRes.timestamp,
    });
    MdMessage.success('导出任务已提交，请在文件列表中查看');
    return true;
  }

  MdMessage.error(reportRes?.msg || '导出失败');
  return false;
}
